export enum TAB_ITEM_SIZE {
  /**
   * @deprecated
   */
  LARGE = 'large',
  /**
   * @deprecated
   */
  MEDIUM = 'medium',
  /**
   * @deprecated
   */
  SMALL = 'small',
  LG = 'lg',
  MD = 'md',
  SM = 'sm',
}

export enum TAB_ITEM_VARIANT {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
